import { useTranslation } from 'react-i18next';
import { replaceFsCount, useButtonAction } from '@/modules/promo';
import { useFsCountFromQuery } from '@/modules/promo/hooks/useFsCountFromQuery';
import { Button } from '../../components/buttons';
import { CopyCode } from '../../components/CopyCode';
import { TermsAndConditions } from '../../components/TermsAndConditions';
import { Loader } from '../Loader';
import { ScScreenModal } from './styled';

interface ScreenModalProps {
  blockImage: string;
  blockImageMobile?: string;
  translation: string;
  copyCode?: string;
  withTermsConditions?: boolean;
}

export const ScreenModal = ({
  blockImage,
  blockImageMobile,
  translation,
  copyCode,
  withTermsConditions = false,
}: ScreenModalProps) => {
  const { t } = useTranslation(translation);
  const { buttonAction, isLoading } = useButtonAction();

  const fsCount = useFsCountFromQuery();

  return (
    <ScScreenModal blockImage={blockImage} blockImageMobile={blockImageMobile}>
      <div className="modal__wrapper">
        <div className="wrapper">
          {t('yourPrize') !== 'yourPrize' && (
            <>
              <h1 className="yourPrize">{t('yourPrize')}</h1>
              <div className="text-wrapper">
                <span className="firstPrize">
                  {replaceFsCount(t('firstPrize'), fsCount)}
                </span>
                <span className="secondPrize">{t('secondPrize')}</span>
              </div>
            </>
          )}
          {t('yourPrize-2') !== 'yourPrize-2' && (
            <div className="text-container">
              <h1 className="yourPrize-2">{t('yourPrize-2')}</h1>
              <p className="firstPrize">
                {replaceFsCount(t('firstPrize'), fsCount)}
              </p>
            </div>
          )}
          {copyCode && (
            <div className="code-container">
              <CopyCode code={copyCode} />
            </div>
          )}
          <div className="inner">
            <Button disabled={isLoading} primary {...buttonAction}>
              {isLoading ? <Loader /> : t('claim')}
            </Button>
            {withTermsConditions && (
              <TermsAndConditions
                title={t('common:button.termsAndConditions')}
                translation={translation}
              />
            )}
          </div>
        </div>
      </div>
    </ScScreenModal>
  );
};
